import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Stkma } from '../entity/Stkma-angular';

export const StkMa019List = [{ id: "0", name: "上市" }, { id: "1", name: "上櫃" }, { id: "2", name: "期貨" }, { id: "3", name: "選擇權" }, { id: "4", name: "興櫃" }, { id: "5", name: "盤中零股-上市" }, { id: "6", name: "盤中零股-上櫃" }, { id: "O", name: "海期" }, { id: "Z", name: "指數" }]; // 商品分類
export const StkMa021List = [{ id: "N", name: "日盤" }, { id: "Y", name: "夜盤" }, { id: "U", name: "美股" }]; // 夜盤
export const StkMa033List = [{ id: "1", name: "正向" }, { id: "-1", name: "反向" }]; // 正反向

@Injectable({
  providedIn: 'root'
})
export class StkmaServicePkg extends JkEntityV2 {
  StkMa019List = StkMa019List;
  StkMa021List = StkMa021List;
  StkMa033List = StkMa033List;


  constructor() {
    super();
    this.linkMasterFields = '';
    this.defaultItem = new Stkma();
    this.entityType.type = EntityType.data;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      MA001: '股票代號', MA002: '名稱', MA003: '融資乘數', MA006: '摘要', MA013: '融券乘數', MA015: '長期投資', MA019: '商品分類', MA020: '刪除', MA021: '夜盤', MA022: '證交稅率%', MA028: 'XQ股票代號', MA029: 'XQ次標題', MA033: '正反向', MA004: '期貨/股票代號', MA005: '小型期貨代號', MA017: '原始保證金適用比例', MA030: '市價日期', MA031: '市價時間', MA043: 'stockIndex', MA044: '最新股本', MA046: '群益期貨對帳代號', MA047: '群組', MA048: '交易所代號', MA049: '交易所名稱', MA034: '商品下單代碼', MA035: '交易所下單代碼', MA036: '期貨結算日', TIME1: '時間起', TIME2: '時間迄', TIME3: '夜盤起', TIME4: '夜盤迄'
    };

    this.fieldNames = 'MA001,MA002,MA003,MA006,MA013,MA015,MA019,MA020,MA021,MA022,MA028,MA029,MA033,MA004,MA005,MA017,MA030,MA031,MA043,MA044,MA046,MA047,MA048,MA049,MA034,MA035,MA036,TIME1,TIME2,TIME3,TIME4';
    this.fieldLengths = { MA001: 20, MA002: 20, MA003: 5.3, MA006: 100, MA013: 5.3, MA015: 1, MA019: 1, MA020: 1, MA021: 1, MA022: 10.6, MA028: 20, MA029: 10, MA033: 2, MA004: 20, MA005: 20, MA017: 5.4, MA030: 8, MA031: 8, MA043: 8.3, MA044: 8.3, MA046: 8, MA047: 500, MA048: 10, MA049: 60, MA034: 16, MA035: 10, MA036: 8, TIME1: 4, TIME2: 4, TIME3: 4, TIME4: 4 };
    this.columnDefs = [
      { field: "MA001", headerName: "股票代號", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "MA002", headerName: "名稱", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "MA003", headerName: "融資乘數", headerTooltip: "", width: 112, cellDataType: "number", },
      { field: "MA006", headerName: "摘要", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "MA013", headerName: "融券乘數", headerTooltip: "", width: 112, cellDataType: "number", },
      { field: "MA015", headerName: "長期投資", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "MA019", headerName: "商品分類", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgComboBoxEditor, cellRendererParams: { list: this.StkMa019List }, },
      { field: "MA020", headerName: "刪除", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "MA021", headerName: "夜盤", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "MA022", headerName: "證交稅率%", headerTooltip: "", width: 155, cellDataType: "number", },
      { field: "MA028", headerName: "XQ股票代號", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "MA029", headerName: "XQ次標題", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "MA033", headerName: "正反向", headerTooltip: "", width: 86, cellDataType: "number", cellRenderer: AgComboBoxEditor, cellRendererParams: { list: this.StkMa033List }, },
      { field: "MA004", headerName: "期貨/股票代號", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "MA005", headerName: "小型期貨代號", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "MA017", headerName: "原始保證金適用比例", headerTooltip: "", width: 113, cellDataType: "number", },
      { field: "MA030", headerName: "市價日期", headerTooltip: "", width: 120, cellDataType: "text", valueFormatter: dateFormatter, },
      { field: "MA031", headerName: "市價時間", headerTooltip: "", width: 134, cellDataType: "text", },
      { field: "MA046", headerName: "群益期貨對帳代號", headerTooltip: "", width: 134, cellDataType: "text", },
      { field: "MA047", headerName: "群組", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "TIME2", headerName: "時間迄", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "TIME4", headerName: "夜盤迄", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "TIME3", headerName: "夜盤起", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "MA035", headerName: "交易所下單代碼", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "TIME1", headerName: "時間起", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "MA036", headerName: "期貨結算日", headerTooltip: "", width: 134, cellDataType: "text", valueFormatter: dateFormatter, },
      { field: "MA034", headerName: "商品下單代碼", headerTooltip: "", width: 198, cellDataType: "text", },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'STKMA';
    this.isSys = false;
    this.sqlSelect = `SELECT STKMA.*  FROM STKMA`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE MA020='N'`;
    this.sqlOrderDefault = ` ORDER BY MA001`;
    this.keyFields = ['MA001'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['MA001'];
    this.seqField = '';
    this.seqFieldLength = 4;
  }
  override async validateItem(item: Stkma): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

override async newRecord(newItem: Stkma): Promise<Stkma> {
    await super.newRecord(newItem);
    return newItem;
  }




}

// 客製開始====================================================
